export { default as HeaderData } from "./common/header";
export { default as FooterData } from "./common/footer";

export { default as HomeData } from "./home";
export { default as AboutData } from "./about";

export { default as DiacData } from "./diac";

